const { NODE_ENV, VUE_APP_ENV } = process.env;

const isOverseas = VUE_APP_ENV.includes('overseas');

const isDev = NODE_ENV === 'development';

// 海外暂时未启用 sso
const ssoMap = {
  dev: 'http://sso.mini.me', // 开发
  beta: 'http://sso.mini.me', // 测试
  prod: 'https://sso.mini1.cn', // 生产
};

const currentSsoUrl = ssoMap[VUE_APP_ENV];

export { isOverseas, isDev, ssoMap, currentSsoUrl };
